// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mAPi","textarea":"styles_textarea__1kTbw"};